export default __webpack_public_path__ + "static/media/MTenn.f6deb2c0.JPG";